import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ROUTES } from '../../common-files/enums/server-routes';

// platform-wide reports (every establishment). The establishment is a query
// filter here, not the branch header.
@Injectable({ providedIn: 'root' })
export class PlatformReportsService {
  constructor(private http: HttpClient) {}

  private params(values: { [key: string]: string | number | boolean | null | undefined }): HttpParams {
    let params = new HttpParams();
    for (const [key, value] of Object.entries(values)) {
      if (value !== null && value !== undefined && value !== '') params = params.set(key, String(value));
    }
    return params;
  }

  getEstablishmentOverview(establishmentId: number | null): Observable<any> {
    return this.http.get(`${ROUTES.PLATFORM_REPORTS}/establishments`, { params: this.params({ establishmentId }) });
  }

  getUtsavOverview(establishmentId: number | null, activeOnly: boolean): Observable<any> {
    return this.http.get(`${ROUTES.PLATFORM_REPORTS}/utsavs`, { params: this.params({ establishmentId, activeOnly }) });
  }

  getAccessAudit(): Observable<any> {
    return this.http.get(`${ROUTES.PLATFORM_REPORTS}/access-audit`);
  }

  getActivity(filters: { from: string; to: string; user?: string; module?: string; method?: string; failuresOnly?: boolean; page?: number }): Observable<any> {
    return this.http.get(`${ROUTES.PLATFORM_REPORTS}/activity`, { params: this.params(filters) });
  }

  getFrontdesk(from: string, to: string, establishmentId: number | null): Observable<any> {
    return this.http.get(`${ROUTES.PLATFORM_REPORTS}/frontdesk`, { params: this.params({ from, to, establishmentId }) });
  }

  getRoleDrift(roleId: number | null): Observable<any> {
    return this.http.get(`${ROUTES.PLATFORM_REPORTS}/role-drift`, { params: this.params({ roleId }) });
  }

  getMediaInventory(): Observable<any> {
    return this.http.get(`${ROUTES.PLATFORM_REPORTS}/media`);
  }

  getFunnel(establishmentId: number | null, utsavId: number | null): Observable<any> {
    return this.http.get(`${ROUTES.PLATFORM_REPORTS}/funnel`, { params: this.params({ establishmentId, utsavId }) });
  }
}
